import { Component, Input, OnInit } from '@angular/core';
import { EvaluationVehicle } from '@app-model/evaluation';

@Component({
  selector: 'app-card-evaluation-other-info',
  templateUrl: './card-evaluation-other-info.component.html',
  styleUrls: ['./card-evaluation-other-info.component.scss']
})
export class CardEvaluationOtherInfoComponent implements OnInit {

  @Input() vehicle: EvaluationVehicle;
  @Input() showAxleAndTire: boolean = false;
  constructor() { }

  ngOnInit(): void {
  }

}
